import React from 'react';

const Icon = () => {
    return (
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.9661 14.2234H5.74609" stroke="#737FA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.9661 10.0369H5.74609" stroke="#737FA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.50109 5.86011H5.74609" stroke="#737FA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.158 0.749756C13.158 0.749756 5.481 0.753756 5.469 0.753756C2.709 0.770756 1 2.58676 1 5.35676V14.5528C1 17.3368 2.722 19.1598 5.506 19.1598C5.506 19.1598 13.182 19.1568 13.195 19.1568C15.955 19.1398 17.665 17.3228 17.665 14.5528V5.35676C17.665 2.57276 15.942 0.749756 13.158 0.749756Z" stroke="#737FA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default Icon;


